'use client';

import { useLayoutEffect, useRef } from 'react';
import { MainHeader } from '../main-header/main-header';

type KioskHeaderProps = {
  onHeaderHeightChange: (height: number) => void;
};

export const KioskHeader = ({ onHeaderHeightChange }: KioskHeaderProps): React.JSX.Element => {
  const headerRef = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const updateHeight = (): void => {
      if (headerRef.current) {
        onHeaderHeightChange(headerRef.current.offsetHeight);
      }
    };

    window.addEventListener('resize', updateHeight);

    const observer = new ResizeObserver(updateHeight);
    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    updateHeight();

    return (): void => {
      window.removeEventListener('resize', updateHeight);
      observer.disconnect();
    };
  }, [onHeaderHeightChange]);

  return (
    <header ref={headerRef}
      className="shadow-sm bg-(--surface) sticky top-[0] z-100"
      data-test="kiosk-header"
    >
      <MainHeader hideNavLinks />
    </header>
  );
};
